import type { CrosswordWord } from './types';

export function wordNumber(word: CrosswordWord): string {
  return word.id.split('-')[1] ?? word.id;
}

export function wordLabel(word: CrosswordWord): string {
  return `${wordNumber(word)} ${word.direction === 'across' ? 'Across' : 'Down'}`;
}
